<p class="mb-4">
  <strong>Mobile Media Content, SL</strong>, (hereinafter
  "<strong>MMC</strong>") is the owner of the Web Site
  <a href="https://3ddigitalvenue.com/" target="_blank"
    >https://3ddigitalvenue.com/</a
  >
  (hereinafter the "Web Site") and uses cookies that collect information related
  to the connection, browsers and devices used by Internet users who access and
  use the Web Site (hereinafter the "<strong>Users</strong>"). MMC uses this
  information to manage and improve the proper functioning of the Website and to
  provide services to <strong>{{ CUSTOMER_NAME }}</strong
  >.
</p>
<p class="mb-4">
  This policy describes what information these cookies collect, how they are
  used and for what purpose. It also indicates how the User can restrict or
  block the automatic downloading of cookies, however, this could reduce or even
  hinder certain elements of the functionality of the Website. Likewise, the
  User can choose the category of cookies that he/she wishes to activate in the
  cookies banner that appears the first time he/she accesses the Website.
</p>

<h2 class="mb-4">1. DEFINITION OF COOKIES</h2>

<p class="mb-4">
  Cookies are small text files that are placed on the User's computer,
  smartphone or other device when accessing the Internet. This is done to
  improve the User's experience and for other purposes, such as recognizing
  Users when accessing the Site, ensuring the security of your account and
  delivering targeted advertising. For more general information about cookies,
  please see the following
  <a
    href="https://es.wikipedia.org/wiki/Cookie_(inform%C3%A1tica)"
    target="_blank"
    >article</a
  >.
</p>

<h2 class="mb-4">2. HOW WE USE COOKIES</h2>

<p class="mb-4">
  In summary, MMC uses the cookies listed in Annex I of this Policy to track how
  the Website is used in order to optimize its operation.
</p>

<h2 class="mb-4">3. WHAT COOKIES WE USE</h2>

<p class="mb-4">The Web Site uses both its own and third-party cookies:</p>

<ol class="list-disc list-inside mb-4 text-sm">
  <li class="mb-4">
    <strong>First-party cookies</strong>: cookies sent to your device by MMC
    through the web domain.
  </li>

  <li class="mb-4">
    <strong>Third-party cookies </strong>: these are sent to your device by
    domains that are not managed by MMC but by another entity that processes the
    data collected through cookies.
  </li>
</ol>

<p class="mb-4">
  According to the purpose of the cookies, the cookies used by MMC can be
  divided into the following categories:
</p>

<ol class="list-disc list-inside mb-4 text-sm">
  <li class="mb-4">
    <strong>Technical cookies (necessary)</strong>: cookies necessary for
    navigation and for the proper functioning of the Website. Their use allows
    basic functions, such as access, secure navigation. The legal basis that
    allows the collection of data through these cookies is the legitimate
    interest of MMC in the management of the Website. No information collected
    through these cookies is shared with third parties. See the cookie table
    below for details of these cookies.
  </li>

  <li class="mb-4">
    <strong>Analytical Cookies</strong>: allow monitoring and analyzing the
    behavior of Users. The information collected through this type of cookie is
    used to measure the activity of the Website and for the elaboration of
    browsing profiles of the Users, in order to improve the Website and its
    services. The legal basis for collecting this data through these cookies is
    the consent of the User. See the table of cookies below for details of these
    cookies.
  </li>
</ol>

<p class="mb-4">
  You can find the detailed list of the cookies we use, the type, purpose and
  duration of each one of them in the table of cookies below (Annex I).
</p>

<h2 class="mb-4">4. DISABLE COOKIES</h2>

<p class="mb-4">
  The User may restrict or limit the placement of cookies by adjusting the
  settings of your browser. However, if you select this setting, you may not be
  able to access certain parts of the Website or the poor display of its
  contents, which will result in less efficient browsing and you may not be able
  to take advantage of some of the services available. Therefore, it is
  recommended that you do not disable them.
</p>

<p class="mb-4">
  If you wish to disable cookies, go to the Browser Preferences menu or Browser
  settings and look for the Privacy section. As an example, you can follow the
  instructions below:
</p>

<ul class="list-disc list-inside mb-4">
  <li>
    <a
      href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09#:~:text=Abre%20Microsoft%20Edge%20y%20selecciona,sitio%20y%20luego%20Borrar%20ahora"
      target="_blank"
      >Microsoft Edge</a
    >
  </li>
  <li>
    <a href="https://support.google.com/chrome/answer/95647" target="_blank"
      >Google Chrome</a
    >
  </li>
  <li>
    <a
      href="http://support.mozilla.org/kb/delete-cookies-remove-info-websites-stored"
      target="_blank"
      >Firefox</a
    >
  </li>
  <li>
    <a
      href="https://support.apple.com/es-es/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
      target="_blank"
      >Safari</a
    >
  </li>
</ul>

<h2 class="mb-4">5. MORE INFORMATION</h2>

<p class="mb-4">
  We hope we have clarified how and why we use cookies. If anything is still
  unclear, please do not hesitate to contact us at:
  <span class="select-none">dpo&#64;mobilemediacontent.com</span>
</p>

<div class="last-updated">Latest version: 2025/04/01</div>
